import { NewAllocationScenario } from 'common/types/allocation';
import { getObjectValue } from 'utilities';
import { FindScenarioByReferenceParams } from './types';

/**
 * Finds an allocation scenario by either its ID or scenario reference.
 * Used to locate scenarios when handling cell changes in equity allocation.
 *
 * @param params - Object containing allocation scenarios and identifiers
 * @returns The matching scenario or undefined if not found
 */
const findScenarioByReference = (params: FindScenarioByReferenceParams): NewAllocationScenario | undefined => {
  const { allocationScenarios, scenarioId, scenarioRef } = params;

  return allocationScenarios?.find(allocationScenario => {
    const { id: currentScenarioId, scenario_ref: currentScenarioRef } = getObjectValue(allocationScenario);

    const matchScenarioIds = currentScenarioId && scenarioId && currentScenarioId === scenarioId;
    const matchScenarioRefs = currentScenarioRef && scenarioRef && currentScenarioRef === scenarioRef;

    return matchScenarioIds || matchScenarioRefs;
  });
};

export default findScenarioByReference;
